<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-private-ip`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.714 1.132a2 2 0 00-1.428 0l-17 6.5A2 2 0 005 9.5V31a2 2 0 00.815 1.611l17 12.5a2 2 0 002.37 0l17-12.5A2 2 0 0043 31V9.5a2 2 0 00-1.286-1.868l-17-6.5zM9 29.988V10.877L24 5.14l15 5.736v19.111l-15 11.03-15-11.03zM16 14v16.5h4V14h-4zm7 2v-2h6.5a5.5 5.5 0 110 11H27v5.5h-4V16zm4 5h2.5a1.5 1.5 0 000-3H27v3z"/></svg>
</template>
<script>

export default {
  name: 'IconPrivateIp',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
